import api from '../../api';

const state = {
  toasts: []
};

// getters
const getters = {};

// actions
const actions = {
  _addToast({ commit, rootState, state }, params = {}) {
    //Set index
    const index = state.toasts.length;
    //Set default values if not present
    if (typeof params.text === 'undefined') {
      params.text = 'Default';
    }
    if (typeof params.duration === 'undefined') {
      params.duration = 5000;
    }
    if (typeof params.variant === 'undefined') {
      params.variant = 'good';
    }
    //Add the toast to the store
    commit('_addToast', {
      index: index,
      text: params.text,
      variant: params.variant
    });
    //After specified duration remove toast.
    setTimeout(function() {
      commit('_removeToast', index);
    }, params.duration);
  }
};

// mutations
const mutations = {
  _addToast(state, toast) {
    state.toasts.unshift(toast);
  },
  _removeToast(state, index) {
    const removeIndex = state.toasts
      .map(function(toast) {
        return toast.index;
      })
      .indexOf(index);
    //If index has been found
    if (index > -1) {
      state.toasts.splice(removeIndex, 1);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
